// https://reactjs.org/docs/code-splitting.html#reactlazy
import React from 'react'

//404
export const Page404 = React.lazy(() => import('./Page404'))
